import { useCollapsedLocation } from "./hooks/useCollapsedLocation"
import { getWearableCardPlaceholderClassName, gridSettings } from "./utils"
import WearableCardWrapper from "./WearableCardWrapper"
import Grid from "@/components/shared/Grid"
import { Icon, IconColor } from "@/components/shared/Icon"
import LazyMount from "@/components/shared/LazyMount"
import { TestId } from "@/constants/globals"
import { Alert } from "@/types/alert"
import { CardSize } from "@/types/index"

interface LocationGroupProps {
   locationId: string
   locationName: string
   wearableIds: string[]
   wearableCardSize: CardSize
   wearableIdsWithActiveAlert: Set<string>
   expandedWearableIds: Set<string>
   everExpandedWearableIds: Set<string>
   smallScreen: boolean
   wearableAlertsByInmateId: Record<string, Alert[]>
   onSwapDeviceClick: (wearableId: string) => void
   onClearAlertClick: (alert: Alert) => void
   onNavigateToInmateDetail: (inmateId: string) => void
   onExpandedChange?: (wearableId: string, isExpanded: boolean) => void
}

const LocationGroup = ({
   locationId,
   locationName,
   wearableIds,
   wearableCardSize,
   wearableIdsWithActiveAlert,
   expandedWearableIds,
   everExpandedWearableIds,
   smallScreen,
   wearableAlertsByInmateId,
   onSwapDeviceClick,
   onClearAlertClick,
   onNavigateToInmateDetail,
   onExpandedChange,
}: LocationGroupProps) => {
   const { isCollapsed, toggleCollapsed } = useCollapsedLocation(locationId)

   return (
      <div className="floor-overview__location-group">
         <span
            className="floor-overview__location-label"
            data-testid={TestId.FLOOR_OVERVIEW_LOCATION_GROUP_LABEL}
            onClick={toggleCollapsed}
         >
            <Icon
               name={isCollapsed ? "arrowRight" : "arrowDown"}
               size="16"
               color={IconColor.COOL_GRAY}
            />
            {locationName}
            {isCollapsed && (
               <span
                  className="floor-overview__location-total-count"
                  data-testid={TestId.FLOOR_OVERVIEW_LOCATION_TOTAL_COUNT}
               >
                  <Icon
                     name="smartwatch"
                     size="24"
                     color={IconColor.HONOLULU_BLUE}
                  />
                  <span className="floor-overview__location-total-count-value">
                     {wearableIds.length}
                  </span>
               </span>
            )}
         </span>
         {!isCollapsed &&
            (wearableIds.length ? (
               <Grid
                  sx={smallScreen ? gridSettings.small : gridSettings.default}
               >
                  {wearableIds.map((wearableId) => (
                     <LazyMount
                        key={`wearable-${wearableId}`}
                        className={getWearableCardPlaceholderClassName(
                           wearableCardSize,
                           wearableIdsWithActiveAlert.has(wearableId) ||
                              expandedWearableIds.has(wearableId)
                        )}
                     >
                        <WearableCardWrapper
                           wearableId={wearableId}
                           alertsByInmateId={wearableAlertsByInmateId}
                           onSwapDeviceClick={onSwapDeviceClick}
                           onClearAlertClick={onClearAlertClick}
                           onNavigateToInmateDetail={onNavigateToInmateDetail}
                           isExpanded={expandedWearableIds.has(wearableId)}
                           isCollapsed={
                              everExpandedWearableIds.has(wearableId) &&
                              !expandedWearableIds.has(wearableId)
                           }
                           onExpandedChange={onExpandedChange}
                        />
                     </LazyMount>
                  ))}
               </Grid>
            ) : (
               <div className="floor-overview__no-presence">
                  No presence detected
               </div>
            ))}
      </div>
   )
}

export default LocationGroup
